import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { DataService } from '../services/data.service';

@Pipe({
    name: 'fieldTranslate',
    standalone: false,
    pure: true
})

@Injectable({ providedIn: 'root' })
export class FieldTranslatePipe implements PipeTransform {
    constructor(private localization: LocalizationService) {}

    transform<T extends { [key: string]: any }>(item: T, field: string): string {
    return this.localization.getFieldForItem(item, field);
  }
}